// Shared fetch helper for state-changing API requests.
//
// The server requires an `X-Requested-With: XMLHttpRequest` header on every
// POST/PUT/PATCH/DELETE to /api/* (CSRF protection — see server/index.ts).
// Routing all mutating calls through this helper guarantees the header is sent;
// forgetting it causes a silent 403 (regression fixed in ICODE-181).

/** Header name + value the CSRF middleware checks for on state-changing requests. */
export const CSRF_HEADER = 'X-Requested-With';
export const CSRF_HEADER_VALUE = 'XMLHttpRequest';

/**
 * fetch() wrapper that always sets the CSRF header (and a JSON Content-Type by
 * default). Use for any POST/PUT/PATCH/DELETE to the API. Caller-supplied
 * headers win, except the CSRF header which is always enforced.
 */
export function apiFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(init.headers as Record<string, string> | undefined),
    [CSRF_HEADER]: CSRF_HEADER_VALUE,
  };
  return fetch(input, { ...init, headers });
}
